import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import LogoUtp from '../assets/images/logo-utp-postgrado.png';
import { Link } from 'react-router-dom';
import { Tools } from '../utils/tools';
import User from "../models/user";
import Global from "../models/global";
import { Global as Globals } from "../services/Global";
import { STEP_MENU, VARIABLES } from '../utils/constants';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class DashboardMenuComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loginTarget: '',
            currentPath: window.location.pathname,
            platform: Tools.platformDevice()
        }
    }

    componentDidMount() {
        let _root = this;
        if (_root.props.glo.loginTarget) {
            _root.setState({
                loginTarget: _root.props.glo.loginTarget
            });
        }
    }

    onClickHideMenu = e => {
        e.preventDefault();

        let _sidebarDashboard = document.getElementById('sidebar-dashboard');
        _sidebarDashboard.style.left = '-500px';
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;

        Global.isLogin = false;
        _root.props.process(User);
        _root.props.general(Global);
        window.location.reload();
    }

    onClickMenuItem = (e) => {
        e.preventDefault();
        let _root = this;

        if (_root.state.currentPath !== e.target.getAttribute('href')) {
            if (_root.props.pro.vistasCompletadas !== '' && Globals.dataIsComplete(_root.props.pro.vistasCompletadas, e.target.getAttribute('href'))) {
                _root.props.navigate(e.target.getAttribute('href'));
            }
            else {
                Tools.showToaster('error', '', 'Aún no has completado los datos de la vista.', 2000);
            }
        }
    }

    render() {
        const {
            currentPath,
            platform
        } = this.state;

        const {
            step,
            form,
        } = this.props;

        return (
            <>
                <div className="row">
                    {(platform === 'mobile') &&
                        <div className="col-sm-12 mt-4 mb-4" style={{ textAlign: 'right' }}>
                            <button onClick={this.onClickHideMenu}><i className="fa fa-times" aria-hidden="true"></i></button>
                        </div>
                    }
                    <div className="col col-sm-12 mt-4 mb-4">
                        <img src={LogoUtp} alt='' />
                    </div>
                </div>
                <div className="row">
                    <div className="col col-sm-12">
                        <h4 className="text-bold">Inicia tu Proceso<br />de Admisión aquí.</h4>
                    </div>
                </div>
                {form &&
                    <div className="row">
                        <div className="col col-sm-12">
                            <ul className="dashboard-menu">
                                <li className="item mt-3 mb-3">
                                    <div>
                                        {(step === STEP_MENU.STEP_DATOS_GENERALES) ?
                                            <span>1</span> :
                                            <span className="check active"><i className="fa fa-check" aria-hidden="true"></i></span>
                                        }
                                        <Link to="/datos-generales" style={{ color: (step === STEP_MENU.STEP_DATOS_GENERALES) && '#049add' }} onClick={this.onClickMenuItem}>Datos Generales</Link>
                                    </div>
                                    {step === STEP_MENU.STEP_DATOS_GENERALES &&
                                        <ul className="dashboard-submenu">
                                            <li className={(currentPath === '/datos-generales') ? 'active' : ''}>
                                                <Link to="/datos-generales" onClick={this.onClickMenuItem}>Datos Personales</Link>
                                            </li>
                                            {(form === VARIABLES.FORM_TYPE_MAES) &&
                                                <>
                                                    <li className={(currentPath === '/datos-adicionales') ? 'active' : ''}>
                                                        <Link to="/datos-adicionales" onClick={this.onClickMenuItem}>Datos Adicionales</Link>
                                                    </li>
                                                    <li className={(currentPath === '/datos-conyuge') ? 'active' : ''}>
                                                        <Link to="/datos-conyuge" onClick={this.onClickMenuItem}>Datos del Cónyuge</Link>
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                    }
                                </li>
                                {(form !== VARIABLES.FORM_TYPE_SEG) &&
                                <li className="item mt-3 mb-3">
                                    <div>
                                        {(step === STEP_MENU.STEP_DATOS_GENERALES || step === STEP_MENU.STEP_HOJA_VIDA) ?
                                            <span>2</span>
                                            : <span className="check active"><i className="fa fa-check" aria-hidden="true"></i></span>
                                        }
                                        <Link to={form === VARIABLES.FORM_TYPE_MAES ?
                                            "/informacion-academica" : "/informacion-laboral"}
                                            style={{ color: (step === '2') && '#049add' }} onClick={this.onClickMenuItem}>
                                            Hoja de Vida
                                        </Link>
                                    </div>

                                    {(step === STEP_MENU.STEP_HOJA_VIDA && form === VARIABLES.FORM_TYPE_MAES) &&
                                        <ul className="dashboard-submenu">
                                            <>
                                                <li className={(currentPath === '/informacion-academica') ? 'active' : ''}><Link to="/informacion-academica" onClick={this.onClickMenuItem}>Información Académica</Link></li>
                                                <li className={(currentPath === '/informacion-laboral') ? 'active' : ''}><Link to="/informacion-laboral" onClick={this.onClickMenuItem}>Información Laboral</Link></li>
                                                <li className={(currentPath === '/datos-laborales') ? 'active' : ''}><Link to="/datos-laborales" onClick={this.onClickMenuItem}>Datos Laborales</Link></li>
                                            </>
                                        </ul>
                                    }
                                </li>
                                }
                                {(form === VARIABLES.FORM_TYPE_MAES) &&
                                    <li className="item mt-3 mb-3">
                                        <div>
                                            {(step === STEP_MENU.STEP_DATOS_GENERALES || step === STEP_MENU.STEP_HOJA_VID || step === STEP_MENU.STEP_CARTA_PRESENTACION) ?
                                                <span>3</span> :
                                                <span className="check active"> <i className="fa fa-check" aria-hidden="true"></i></span>
                                            }
                                            <Link to="/carta-presentacion" style={{ color: (step === STEP_MENU.STEP_CARTA_PRESENTACION) && '#049add' }} onClick={this.onClickMenuItem}>Carta de Presentación</Link>
                                        </div>
                                    </li>
                                }
                                <li className="item mt-3 mb-3">
                                    <div>
                                        <span>{(form === VARIABLES.FORM_TYPE_MAES) ? 4 : 3}</span>
                                        <Link to="/forma-pago" onClick={this.onClickMenuItem}>Documentación</Link>
                                    </div>
                                    {step === '4' &&
                                        <ul className="dashboard-submenu">
                                            <li className={(currentPath === '/forma-pago') ? 'active' : ''}><Link to="/forma-pago" onClick={this.onClickMenuItem}>Forma de Pago</Link></li>
                                            <li className={(currentPath === '/documentacion') ? 'active' : ''}><Link to="/documentacion" onClick={this.onClickMenuItem}>Documentación</Link></li>
                                        </ul>
                                    }
                                </li>
                            </ul>
                            <div className="col-sm-12 text-center">
                                <button onClick={this.onClickNext} className="btn btn-primary btn-style-4 w-80">Cerrar Sesión</button>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardMenuComponent);